import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import './Carousel.scss';
import { useSelector } from 'react-redux';

const DEFAULT_BREAKPOINTS = {
  '360': {
    slidesPerView: 3,
  },
  '993': {
    slidesPerView: 5,
  },
};

SwiperCore.use([Pagination, Navigation]);
const Carousel = ({ customBreakpoints, data, title }) => {
  const {
    playingLive_player_general_icon_backChannel: prev,
    playingLive_player_general_icon_nextChannel: next,
  } = useSelector(state => state.asset);

  return (
    <div className="carousel-container">
      <div className="carousel-container__header">
        <h2 className="carousel-container__header__title">{title}</h2>
        <div className="carousel-container__header__navigation">
          <img
            className="carousel-container__header__navigation__prev-btn"
            src={prev}
            alt="back"
          />
          <img
            className="carousel-container__header__navigation__next-btn"
            src={next}
            alt="next"
          />
        </div>
      </div>
      <Swiper
        breakpoints={customBreakpoints || DEFAULT_BREAKPOINTS}
        navigation={{
          nextEl: '.carousel-container__header__navigation__next-btn',
          prevEl: '.carousel-container__header__navigation__prev-btn',
        }}
        spaceBetween={24}
        slidesPerView={1}
        style={{ marginTop: 24 }}
        watchOverflow
        loop
      >
        {data?.map(elem => (
          <SwiperSlide key={elem.id}>{elem.Component}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

Carousel.propTypes = {
  customBreakpoints: PropTypes.object,
  title: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      Component: PropTypes.element,
    }),
  ),
};

export default Carousel;
